import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import AvatarViewer from "../components/viewers/AvatarViewer";
import AvatarConfirmed from "./AvatarConfirmed";
import { useTranslation } from "react-i18next";
import { AvatarAction } from "../redux/actions/AvatarAction";
import { AppConstant, AvatarConstant } from "../redux/reducers";
import { MBackspace, MDotActive, MDotEmpty, MDotFill, MDotWrong } from "../components/commons/MIcon";
import { Col, Container, Row } from "react-bootstrap";
import MButton from "../components/commons/MButton";
import MPageHeader from "../components/commons/MPageHeader";


const NumberPanel = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "", label: "" },
  { value: "0", label: "0" },
  { value: -1, label: MBackspace, isComponent: true },
];


const AvatarConfirmedViewer = ({ avatarStatus, avatarPassword, avatarPasswordExpiredAt, ComparePasswordToServer, UpdateAvatarToUserConfirm }) => {
  const [t] = useTranslation();
  // const [isImportViewer, setIsImportViewer] = useState(false);
  // const [allowPassword, setAllowPassword] = useState(false);

  // // useEffect(() => {
  // //   if (avatarPassword) {
  // //     const now = new Date().getTime();
  // //     setAllowPassword(now < avatarPasswordExpiredAt);
  // //   } else {
  // //     setAllowPassword(false);
  // //   }
  // // }, [avatarPassword, avatarPasswordExpiredAt])

  // useEffect(() => {
  //   allowPassword && setIsImportViewer(true);
  // }, [allowPassword]);

  const [passwordStrList, setPasswordStrList] = useState((new Array(4)).fill(null));
  const [passwordStep, setPasswordStep] = useState(0);
  const [passwordStepDone, setPasswordStepDone] = useState(false);
  const [isMissMatching, setIsMissMatching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showViewer, setShowViewer] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setPasswordStrList((new Array(4)).fill(null));
    setPasswordStep(0);
    setPasswordStepDone(false);
  }, []);

  useEffect(() => {
    setPasswordStepDone(passwordStrList.every(x => !!x));
  }, [passwordStrList]);


  const setPassword = useCallback((val) => {
    if (passwordStrList.every(x => !!x) && val !== -1) {
      return;
    }
    setLoading(false);
    if (val === -1) {
      if (passwordStep > 0) {
        setIsMissMatching(false);
        setPasswordStrList(prev => {
          const tmp = [...prev];
          tmp[passwordStep - 1] = null;
          return tmp;
        });
        setPasswordStep(prev => prev - 1);
      }
    } else if (!!val) {
      setIsMissMatching(false);
      setPasswordStrList(prev => {
        const tmp = [...prev];
        tmp[passwordStep] = val;
        return tmp;
      });
      setPasswordStep(prev => prev + 1);
    }
  }, [passwordStep, passwordStrList]);

  const checkPassword = useCallback(async () => {
    if (!passwordStepDone || loading) {
      return;
    }
    setLoading(true);
    setIsMissMatching(false);
    const password = passwordStrList.join("");
    const ret = await ComparePasswordToServer(password);
    if (ret?.data?.result) {
      dispatch({ type: AvatarConstant.SET_PASSWORD, value: password });
      setShowViewer(true);
      // await UpdateAvatarToUserConfirm();
      // handlerClose();
    } else {
      setIsMissMatching(true);
      setPasswordStep(0);
      setPasswordStepDone(false);
      setPasswordStrList((new Array(4)).fill(null));
    }
    // setLoading(false);
  }, [passwordStepDone, loading, passwordStrList, ComparePasswordToServer, dispatch]);

  useEffect(() => {
    if (passwordStepDone && !loading && !showViewer) {
      checkPassword();
    }
  }, [passwordStepDone, loading, showViewer, checkPassword])


  return <div className="w-100 h-100 d-flex flex-column user-select-none p-0">
    {!showViewer && <>
      <MPageHeader isWhite={true} css="bg-primary" />
      <div
        className="d-flex flex-fill flex-column justify-content-center align-items-center bg-primary text-white text-center"
        style={{ maxHeight: 266 }}
      >
        <div className="fs-1 fw-bolder px-4">
          {t("Enter password")}
        </div>
        {!isMissMatching && <>
          <div className="mt-2 px-2 fs-7" style={{ height: 50 }}>
            {t("Please enter your password.")}
          </div>
        </>}
        {isMissMatching && <>
          <div className="mt-2 px-2 fs-7 text-danger-600" style={{ height: 50 }}>
            {t("Please enter your password again.")}
          </div>
        </>}
        <div className="pt-2 pb-5 d-flex align-items-center justify-content-around px-5" style={{ gap: 40 }}>
          {!isMissMatching && <>
            {passwordStrList.map((x, idx) => <div key={idx}>
              {idx === passwordStep && <><MDotActive /></>}
              {idx !== passwordStep && <>
                {!x && <><MDotEmpty /></>}
                {x && <><MDotFill /></>}
              </>}
            </div>)}
          </>}
          {isMissMatching && <>
            {passwordStrList.map((x, idx) => <div key={idx}>
              <MDotWrong />
            </div>)}
          </>}
        </div>
      </div>
      <Container className="mt-2">
        <Row>
          {NumberPanel.map((x, idx) => <Col
            xs={4}
            key={x.value || `key-${idx}`}
            className="d-flex align-items-center justify-content-center g-4 fw-bolder fs-3 cursor-pointer"
            onClick={() => setPassword(x.value)}
          >
            <div className={x?.isBack && passwordStep === 0 ? "text-gray-300" : ""}>
              {!x?.isComponent && <>
                {x.label}
              </>}
              {x?.isComponent && <>
                {React.createElement(x.label, {
                  className: passwordStep === 0 ? "text-gray-400" : "text-black"
                })}
              </>}
            </div>
          </Col>)}
        </Row>
      </Container>
    </>}
    {showViewer && <>
      <AvatarViewer />
    </>}

    {/* {!isImportViewer && <>
      <AvatarConfirmed userConfirmed={true} />
    </>}
    {isImportViewer && <>
      <AvatarViewer />
    </>} */}
  </div>
};

const mapState = (state) => {
  const avatarStatus = state.AvatarReducer.status;
  const avatarPassword = state.AvatarReducer.password;
  const avatarPasswordExpiredAt = state.AvatarReducer.passwordExpiredAt;
  return { avatarStatus, avatarPassword, avatarPasswordExpiredAt };
};

const mapDispatch = dispatch => ({
  // setPageTitle: (title) => dispatch(AppAction.SetPageTitle(title)),
  ComparePasswordToServer: (password) => dispatch(AvatarAction.ComparePasswordToServer(password)),
  UpdateAvatarToUserConfirm: () => dispatch(AvatarAction.UpdateAvatarToUserConfirm()),
})

export default connect(mapState, mapDispatch)(AvatarConfirmedViewer);
